import gql from 'graphql-tag';

export default gql`
  fragment GenericResponseFragment on GenericResponse {
    message
    success
  }
`;
